import { render, staticRenderFns } from "./GZQDEVPX.vue?vue&type=template&id=205137ae&scoped=true"
import script from "./GZQDEVPX.vue?vue&type=script&lang=js"
export * from "./GZQDEVPX.vue?vue&type=script&lang=js"
import style0 from "./GZQDEVPX.vue?vue&type=style&index=0&id=205137ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205137ae",
  null
  
)

export default component.exports